import { useCallback } from 'react';
import { m } from 'framer-motion';
// @mui
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import { usePopover } from 'minimal-shared/hooks';
// locales
import { useLocales } from 'src/locales';
// components
import { transitionTap, varHover, varTap } from 'src/components/animate';
import { CustomPopover } from 'src/components/custom-popover';
import { MenuList } from '@mui/material';
import { FlagIcon } from 'src/components/flag-icon';
// ----------------------------------------------------------------------
type langType = 'en' | 'it';

export default function LanguagePopover() {
  const locales = useLocales();

  const popover = usePopover();

  const handleChangeLang = useCallback(
    (newLang: langType) => {
      locales.onChangeLang(newLang);
      popover.onClose();
    },
    [locales, popover],
  );

  const renderActionButton = () => (
    <IconButton
      component={m.button}
      whileTap={varTap(0.96)}
      whileHover={varHover(1.04)}
      transition={transitionTap()}
      aria-label="Languages button"
      onClick={popover.onOpen}
      sx={{
        width: 40,
        height: 40,
        ...(popover.open && {
          bgcolor: 'action.selected',
        }),
      }}
    >
      <FlagIcon code={locales.currentLang.countryCode} sx={{ borderRadius: 0.65, width: 28 }} />
    </IconButton>
  );

  const renderMenuActions = () => (
    <CustomPopover open={popover.open} anchorEl={popover.anchorEl} onClose={popover.onClose}>
      <MenuList sx={{ width: 160, minHeight: 72 }}>
        {locales.allLangs?.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === locales.currentLang.value}
            onClick={() => handleChangeLang(option.value)}
          >
            <FlagIcon code={option.countryCode} />
            {option.label}
          </MenuItem>
        ))}
      </MenuList>
    </CustomPopover>
  );

  return (
    <>
      {renderActionButton()}
      {renderMenuActions()}
    </>
  );
}
